"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionOperationSuccess = exports.authenticated = exports.login = exports.signup = void 0;
const typebox_1 = require("@sinclair/typebox");
const personalInfo_1 = require("./personalInfo");
const string_1 = require("../options/string");
/**
 * Used by the signup endpoints to track user input required for creation
 * of a new user. This is essentially the same as {@link fullPersonalInfo}.
 */
exports.signup = personalInfo_1.fullPersonalInfo;
/**
 * Used by the login endpoints to receive the login information of some user.
 */
exports.login = typebox_1.Type.Object({
    username: typebox_1.Type.String({
        description: 'username string',
        example: 'john@example.com',
        minLength: 1,
    }),
    password: personalInfo_1.password,
});
/**
 * Used by the Server to return a user ID to the Backend upon successful user authentication.
 */
exports.authenticated = typebox_1.Type.Object({
    userID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique id' })),
});
/**
 * A response body type to indicate that a session operation (signup/login/logout) succeeded
 */
exports.sessionOperationSuccess = typebox_1.Type.Null({
    description: 'session operation succeeded',
});
//# sourceMappingURL=session.js.map